import { render, staticRenderFns } from "./wechatServerForm.vue?vue&type=template&id=fe79e542&scoped=true"
import script from "./wechatServerForm.vue?vue&type=script&lang=js"
export * from "./wechatServerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe79e542",
  null
  
)

export default component.exports